import React, { useState, useContext } from "react";
import userTypes from "venuescanner-js/constants/user_type";
import AutomatedMessageText from "../../AutomatedMessageText";

import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import { transposeMessageContent } from "./transpose";

const AutomatedMessageCallFeedback = ({ thread, message, children }) => {
  const [showDataFor] = useState(
    thread.viewerRole === userTypes.organiser
      ? userTypes.organiser
      : userTypes.host
  );
  const { activeUser } = useContext(ViewContext);
  const [successful, text] = transposeMessageContent({
    activeUser,
    message,
    showDataFor,
  });
  return (
    <AutomatedMessageText
      tagTitle={successful ? "Call" : "Failed Call"}
      tagClass={
        successful
          ? ["automated-message-call-successful"]
          : ["automated-message-call-failed"]
      }
    >
      {children}
      <div>{text}</div>
    </AutomatedMessageText>
  );
};

export default AutomatedMessageCallFeedback;
